import { isNullOrUndefined } from "utils";

import { CellColor } from "../styles/cellStyles";

export const getCellState = ({
  monthUsage,
  monthBillType,
  hasNullUsage,
  isBeforeStart,
  isAfterEnd,
  isCurrentCellSelected,
  hasHistoricalData,
  hasEstimate,
}: {
  monthUsage: number | null;
  monthBillType: string;
  hasNullUsage: boolean;
  isBeforeStart: boolean;
  isAfterEnd: boolean;
  isCurrentCellSelected: boolean;
  hasHistoricalData: boolean;
  hasEstimate: boolean;
}): { color: CellColor } => {
  // Deactivated
  if (isBeforeStart || isAfterEnd) {
    return { color: "deactivated" };
  }

  if (hasEstimate) {
    return { color: "info" };
  }

  if (hasHistoricalData) {
    return { color: "deactivated" };
  }

  // No data
  if (isNullOrUndefined(monthUsage)) {
    return { color: "error" };
  }

  // Partial data
  if (hasNullUsage) {
    return {
      color: isCurrentCellSelected ? "selected" : "warning",
    };
  }

  // Actual - Interpolation - Extrapolation
  if (monthBillType === "MIXED") {
    return {
      color: isCurrentCellSelected ? "selected" : "mixed",
    };
  }

  // Interpolation - Extrapolation
  if (monthBillType === "INTERPOLATION" || monthBillType === "EXTRAPOLATION") {
    return {
      color: isCurrentCellSelected ? "selected" : "info",
    };
  }

  // Default
  return {
    color: isCurrentCellSelected ? "selected" : "none",
  };
};
